const getTemplates = (store) => {
  return {
    templates: store.root.templatesStore.templates || [],
    defaultSelectedTemplateId: store.root.templatesStore.defaultSelectedTemplateId || null,
    lastUsedTemplates: store.root.templatesStore.lastUsedTemplates || {},
    lastUsedGroupId: store.root.groupsStore.lastUsedGroupId || '',
  };
};

module.exports = {
  getTemplates,
};
